import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type ModalDialog } from '@/scripts/theme/modal-dialog'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class ModalOpener extends UcoastEl {
  static htmlSelector = 'modal-opener'

	constructor() {
		super()

		const trigger = this.querySelector<HTMLElement>('button, a[href]')
		if (!trigger) return

		trigger.addEventListener('click', (event) => {
			const modalSelector = this.getAttribute('data-modal')
			if (!modalSelector) return
			const modal = q.os<ModalDialog>(modalSelector)
			if (!modal) return
			event.preventDefault()
			modal.show(trigger)
		})
	}
}
